import { constantsActive } from 'utils/constants/constants'

export default class ObjectCompany {
	
	static defaults = {
		active: constantsActive.YES,
	}
}
